import { render } from "./Advertising.vue?vue&type=template&id=5a760b1d"
const script = {}

import "./Advertising.vue?vue&type=style&index=0&id=5a760b1d&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__